import React from 'react'
import ACard from '../../Materials/ACard'

const Home = () => {
  return (
    <ACard>
      <h1>Home</h1>
      <ACard>Content 1</ACard>
      <ACard>Content 2</ACard>
      <ACard>Content 3</ACard>
      <ACard>Content 4</ACard>
      <ACard>Content 5</ACard>
      <ACard>Content 6</ACard>
      <ACard>Content 7</ACard>
      <ACard>Content 8</ACard>
      <ACard>Content 9</ACard>
      <ACard>Content 10</ACard>

    </ACard>      

  )
}

export default Home